/* MM 25-10-2026 · Fricción de compra (auditoría UX del 25/10, lotes A y B). Script clásico, sin dependencias.
   A1 burbuja de ayuda que no tapa botones · A2 seQura sin saltos · A3 sin talla marcada hasta elegir
   B  «Ver más productos» · contador de la colección al filtrar · «Ordenar» en móvil · aviso del mínimo de los cupones
      · respuesta inmediata al pulsar «Añadir», cantidades y «Pagar».
   Rollback: quitar el <script> y el stylesheet_tag de mm-ux en layout/theme.liquid. */
(function () {
  if (window.mmUx) return;
  window.mmUx = 1;

  var mq = window.matchMedia('(max-width: 749px)');
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function miles(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function eur(c) { var p = (Math.round(c) / 100).toFixed(2).split('.'); return miles(p[0]) + ',' + p[1] + ' €'; }

  /* ---------------------------------------------------------------- A3 · talla sin preseleccionar */
  var picked = {};
  var free = {};
  var conVariante = /[?&]variant=\d/.test(location.search);

  function mainVp() { return $('main variant-picker'); }
  function pid(vp) { return vp.getAttribute('data-product-id') || 'x'; }
  function grupos(vp) {
    return $$('fieldset.variant-option', vp).filter(function (fs) { return fs.querySelectorAll('input[type="radio"]').length > 1; });
  }
  function nombre(fs) {
    var i = fs.querySelector('input[data-option-name]');
    if (i) return i.getAttribute('data-option-name');
    var l = fs.querySelector('legend');
    return l ? l.textContent.trim() : 'opción';
  }
  function pendientes(vp) {
    if (!vp) return [];
    var id = pid(vp);
    if (free[id]) return [];
    var p = picked[id] || {};
    return grupos(vp).filter(function (fs) { return !p[nombre(fs)]; });
  }
  function ambito(vp) { return vp.closest('dialog') || vp.closest('.shopify-section') || vp.closest('main') || document; }

  function aplicaGate() {
    document.body.classList.remove('mm-gate-init');
    var main = mainVp();
    if (main && conVariante) free[pid(main)] = 1;
    $$('variant-picker').forEach(function (vp) {
      var pend = pendientes(vp);
      grupos(vp).forEach(function (fs) { fs.classList.toggle('mm-nopick', pend.indexOf(fs) > -1); });
      var txt = pend.length ? 'Elige ' + nombre(pend[0]).toLowerCase() : '';
      $$('product-form-component button[name="add"]', ambito(vp)).forEach(function (b) {
        if (txt) { b.classList.add('mm-gate-btn'); b.setAttribute('data-mm-label', txt); }
        else if (b.classList.contains('mm-gate-btn')) { b.classList.remove('mm-gate-btn'); b.removeAttribute('data-mm-label'); }
      });
      if (vp === main) {
        $$('sticky-add-to-cart').forEach(function (st) {
          st.classList.toggle('mm-gate', !!txt);
          var sb = st.querySelector('.sticky-add-to-cart__button');
          if (sb) { if (txt) sb.setAttribute('data-mm-label', txt); else sb.removeAttribute('data-mm-label'); }
        });
      }
    });
  }

  function avisa(fs) {
    fs.classList.remove('mm-warn');
    void fs.offsetWidth;
    fs.classList.add('mm-warn');
    fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var b = fs.querySelector('input');
    if (b) setTimeout(function () { try { b.focus({ preventScroll: true }); } catch (e) {} }, 400);
    clearTimeout(fs._mmT);
    fs._mmT = setTimeout(function () { fs.classList.remove('mm-warn'); }, 2600);
  }

  function marca(input) {
    var vp = input.closest('variant-picker');
    if (!vp) return;
    var id = pid(vp);
    (picked[id] = picked[id] || {})[input.getAttribute('data-option-name') || nombre(input.closest('fieldset'))] = 1;
    aplicaGate();
  }

  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var lab = t.closest('variant-picker label, variant-picker input[type="radio"]');
    if (lab) {
      var inp = lab.matches('input') ? lab : lab.querySelector('input[type="radio"]');
      if (inp) marca(inp);
      return;
    }
    var b = t.closest('button[name="add"], .sticky-add-to-cart__button, [data-mmkit-add]');
    if (!b) return;
    var vp;
    if (b.matches('.sticky-add-to-cart__button, [data-mmkit-add]')) vp = mainVp();
    else {
      var sc = b.closest('dialog') || b.closest('.shopify-section');
      vp = sc && sc.querySelector('variant-picker');
      if (vp && !b.closest('product-form-component')) vp = null;
    }
    if (!vp) return;
    var pend = pendientes(vp);
    if (!pend.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    avisa(pend[0]);
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('variant-picker input[type="radio"]')) marca(t);
  }, true);

  /* ---------------------------------------------------------------- A1 · burbuja de ayuda */
  var INTERACTIVO = 'button, input, select, textarea, summary, [role="button"], a.button, a[class*="button"], a[class*="btn"], .quick-add__button, label.variant-option__button-label';
  function compruebaFab() {
    var mmc = document.getElementById('mmc');
    var fab = document.getElementById('mmc-fab');
    if (!mmc || !fab) return;
    var abierto = fab.getAttribute('aria-expanded') === 'true';
    var fuera = false;
    if (!abierto) {
      if (mq.matches && $('main[data-template^="product"]')) fuera = true;
      else {
        /* Cualquier botón o enlace-botón visible cuya caja se cruce con la burbuja (con 6 px de margen) y que esté
           realmente encima en ese punto (no tapado por otra capa). */
        var r = fab.getBoundingClientRect();
        if (r.width) {
          var L = r.left - 6, T = r.top - 6, R = r.right + 6, B = r.bottom + 6;
          var vw = window.innerWidth * window.innerHeight;
          var cand = document.querySelectorAll(INTERACTIVO);
          for (var i = 0; i < cand.length && !fuera; i++) {
            var it = cand[i];
            if (mmc.contains(it)) continue;
            var q = it.getBoundingClientRect();
            if (!q.width || q.right < L || q.left > R || q.bottom < T || q.top > B) continue;
            if (q.width * q.height > vw * 0.4) continue;
            var x = (Math.max(L, q.left) + Math.min(R, q.right)) / 2, y = (Math.max(T, q.top) + Math.min(B, q.bottom)) / 2;
            var pila = document.elementsFromPoint(Math.min(Math.max(x, 0), window.innerWidth - 1), Math.min(Math.max(y, 0), window.innerHeight - 1));
            for (var k = 0; k < pila.length; k++) {
              if (mmc.contains(pila[k])) continue;
              if (it === pila[k] || it.contains(pila[k])) fuera = true;
              break;
            }
          }
        }
      }
    }
    mmc.classList.toggle('mm-away', fuera);
  }

  /* ---------------------------------------------------------------- A2 · seQura sin saltos */
  function sequra() {
    $$('main .tax-note').forEach(function (tn) {
      if (tn._mmSq) return;
      tn._mmSq = 1;
      var t0 = Date.now(), prev = 0;
      (function mira() {
        var w = tn.querySelector('.sequra-promotion-widget');
        var f = w && w.querySelector('iframe');
        var h = f ? Math.round(parseFloat(f.style.height) || 0) : 0;
        /* Altura que pide seQura (estilo en línea), no la pintada, que lleva +4 px del CSS. Solo alturas estables y razonables: al cambiar de variante el iframe pasa un instante por 100-150 px. */
        if (h >= 20 && h <= 80 && h === prev) document.documentElement.style.setProperty('--mm-sq-h', h + 'px');
        prev = h;
        if (!w && Date.now() - t0 > 8000) { tn.classList.add('mm-sq-none'); return; }
        if (Date.now() - t0 < 60000) setTimeout(mira, w ? 400 : 250);
      })();
    });
  }

  /* ---------------------------------------------------------------- 26-10 · Cuota de seQura en tarjetas y carrito
     Las cifras las calcula seQura (incluye su comisión por cuota): en tarjetas usamos su mini-widget («Desde X €/mes»),
     que el CSS del 22-10 ocultaba en todas; ahora se muestra solo desde 150 €. En el carrito se pinta con la misma función
     de seQura bajo el total. */
  function sequraCuotas() {
    $$('product-card .sequra-educational-popup').forEach(function (e) {
      e.classList.toggle('mm-sq-on', (Number(e.getAttribute('data-amount')) || 0) >= 15000);
    });
    var F = window.SequraWidgetFacade;
    if (!F || !window.Sequra || !Sequra.computeCreditAgreements || !F.drawMiniWidgetOnElement) return;
    $$('.cart-totals .cart-totals__total').forEach(function (t) {
      var val = t.querySelector('.cart-totals__total-value');
      if (!val) return;
      var host = t.parentNode.querySelector('.mm-sq-cart');
      if (!host) { host = document.createElement('div'); host.className = 'mm-sq-cart'; t.insertAdjacentElement('afterend', host); }
      var cents = F.textToCents(val.textContent.trim());
      if (!(cents >= 15000)) { if (host.firstChild) host.innerHTML = ''; return; }
      try { F.drawMiniWidgetOnElement({ product: 'pp3', message: 'o desde %s/mes con seQura', messageBelowLimit: '' }, host, val); } catch (e) {}
    });
  }

  /* ---------------------------------------------------------------- B · contador de la colección */
  function totalProductos() {
    var t = $$('.products-count-wrapper').map(function (e) { return e.textContent; }).filter(function (x) { return /\d/.test(x); })[0];
    if (!t) return null;
    var n = parseInt(t.replace(/\D/g, ''), 10);
    return isNaN(n) ? null : n;
  }
  function contador() {
    var el = $('.mm-colhead__n');
    var n = totalProductos();
    if (!el || n === null) return;
    var txt = miles(n) + (n === 1 ? ' producto' : ' productos');
    if (el.textContent !== txt) el.textContent = txt;
  }

  /* ---------------------------------------------------------------- B · «Ver más productos» */
  function verMas() {
    $$('results-list').forEach(function (rl) {
      var next = rl.querySelector('[ref="viewMoreNext"]');
      var grid = rl.querySelector('[ref="grid"]');
      if (!next || !grid) return;
      next.classList.add('mm-vm-sentinel');
      var cards = grid.querySelectorAll(':scope > [ref="cards[]"]');
      var ultima = cards.length ? Number(cards[cards.length - 1].getAttribute('data-page')) || 1 : 1;
      var paginas = Number(grid.getAttribute('data-last-page')) || 1;
      var box = rl.querySelector('.mm-vm');
      if (!box) {
        box = document.createElement('div');
        box.className = 'mm-vm';
        box.innerHTML = '<p class="mm-vm__n"></p><div class="mm-vm__bar" aria-hidden="true"><span></span></div><button type="button" class="mm-vm__btn">Ver más productos</button>';
        next.insertAdjacentElement('afterend', box);
        box.querySelector('.mm-vm__btn').addEventListener('click', function () {
          var antes = grid.querySelectorAll(':scope > [ref="cards[]"]').length;
          box.classList.add('is-loading');
          this.textContent = 'Cargando…';
          next.classList.add('mm-vm-go');
          var t0 = Date.now();
          (function espera() {
            var ahora = grid.querySelectorAll(':scope > [ref="cards[]"]').length;
            if (ahora > antes || Date.now() - t0 > 9000) {
              next.classList.remove('mm-vm-go');
              box.classList.remove('is-loading');
              box.querySelector('.mm-vm__btn').textContent = 'Ver más productos';
              verMas();
              var nueva = grid.querySelectorAll(':scope > [ref="cards[]"]')[antes];
              var a = nueva && nueva.querySelector('a[href]');
              if (a) try { a.focus({ preventScroll: true }); } catch (e) {}
              return;
            }
            setTimeout(espera, 120);
          })();
        });
      }
      var total = totalProductos() || cards.length;
      var vistos = Math.min(cards.length, total);
      box.hidden = ultima >= paginas || vistos >= total;
      box.querySelector('.mm-vm__n').textContent = 'Has visto ' + miles(vistos) + ' de ' + miles(total) + ' productos';
      box.querySelector('.mm-vm__bar > span').style.width = Math.round((vistos / Math.max(total, 1)) * 100) + '%';
    });
  }

  /* ---------------------------------------------------------------- B · ordenar */
  var NOMBRES = {
    'Características': 'Destacados',
    'Alfabéticamente, A-Z': 'Nombre, A-Z',
    'Alfabéticamente, Z-A': 'Nombre, Z-A',
    'Fecha: antiguo(a) a reciente': 'Más antiguos',
    'Fecha: reciente a antiguo(a)': 'Más nuevos'
  };
  function renombra() {
    $$('sorting-filter-component, .mm-sort').forEach(function (c) {
      if (c._mmRen && c._mmRen === c.innerHTML.length) return;
      var w = document.createTreeWalker(c, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = w.nextNode())) {
        var t = n.nodeValue.trim();
        if (NOMBRES[t]) n.nodeValue = n.nodeValue.replace(t, NOMBRES[t]);
      }
      c._mmRen = c.innerHTML.length;
    });
  }
  function ordenarMovil() {
    var wrap = $('.facets-toggle__wrapper');
    var src = $('select[name="sort_by"]');
    if (!wrap || !src || wrap.querySelector('.mm-sort')) return;
    var lab = document.createElement('label');
    lab.className = 'mm-sort';
    var s = document.createElement('select');
    s.setAttribute('aria-label', 'Ordenar productos');
    var actual = '';
    [].forEach.call(src.options, function (o) {
      var t = NOMBRES[o.text.trim()] || o.text.trim();
      var sel = o.selected || o.hasAttribute('selected');
      if (sel) actual = t;
      s.add(new Option(t, o.value, sel, sel));
    });
    var sp = document.createElement('span');
    sp.className = 'mm-sort__t';
    sp.innerHTML = 'Ordenar' + (actual ? ': <b></b>' : '');
    if (actual) sp.querySelector('b').textContent = actual;
    s.addEventListener('change', function () {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      location.href = u.toString();
    });
    lab.appendChild(sp);
    lab.appendChild(s);
    wrap.appendChild(lab);
  }

  /* ---------------------------------------------------------------- B · cupón por debajo del mínimo */
  var MINIMOS = { BIENVENIDOS5: 6900, DESC5: 2000 };
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('.cart-discount__form')) return;
    var i = f.querySelector('input[name="discount"]');
    var code = (i && i.value || '').trim().toUpperCase();
    var t0 = Date.now();
    (function mira() {
      var err = $$('[ref="cartDiscountErrorDiscountCode"]').filter(function (x) { return !x.classList.contains('hidden'); })[0];
      if (err) return mensaje(err, code);
      if (Date.now() - t0 < 6000) setTimeout(mira, 150);
    })();
  }, true);
  function mensaje(err, code) {
    if (!err.hasAttribute('data-mm-orig')) err.setAttribute('data-mm-orig', err.textContent.trim());
    var orig = err.getAttribute('data-mm-orig');
    if (!MINIMOS[code]) { err.textContent = orig; return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var sub = c.items_subtotal_price || 0;
      if (sub < MINIMOS[code]) {
        err.textContent = code + ' es válido en pedidos desde ' + eur(MINIMOS[code]) + '. Te faltan ' + eur(MINIMOS[code] - sub) + ': cuando llegues, se aplica solo.';
      } else err.textContent = orig;
    }).catch(function () {});
  }

  /* ---------------------------------------------------------------- B · respuesta inmediata */
  var enCurso = 0, finCarrito = 0;
  var fetchPrevio = window.fetch;
  window.fetch = function () {
    var a = arguments[0];
    var u = typeof a === 'string' ? a : (a && a.url) || '';
    var esCarrito = /\/cart(\/|\.js|$|\?)/.test(u);
    var p = fetchPrevio.apply(this, arguments);
    if (esCarrito) {
      enCurso++;
      var fin = function () { enCurso = Math.max(0, enCurso - 1); finCarrito = Date.now(); };
      p.then(fin, fin);
    }
    return p;
  };
  function ocupado(el, texto) {
    if (!el || el.classList.contains('mm-busy')) return;
    el.classList.add('mm-busy');
    el.setAttribute('aria-busy', 'true');
    el._mmT0 = Date.now();
    if (texto) {
      var s = el.querySelector('.button-text') || el;
      el._mmTxt = s.textContent;
      s.textContent = texto;
    }
    vigila();
  }
  function libera(el) {
    el.classList.remove('mm-busy');
    el.removeAttribute('aria-busy');
    if (el._mmTxt != null) { (el.querySelector('.button-text') || el).textContent = el._mmTxt; el._mmTxt = null; }
  }
  var vigilando = false;
  function vigila() {
    if (vigilando) return;
    vigilando = true;
    (function tick() {
      var quedan = $$('.mm-busy, .mm-updating');
      var dialogo = !!$('dialog[open]');
      quedan.forEach(function (el) {
        if (el._mmPago) { if (Date.now() - el._mmT0 > 12000) libera(el); return; }
        var edad = Date.now() - (el._mmT0 || 0);
        var hecho = (enCurso === 0 && finCarrito > (el._mmT0 || 0) && Date.now() - finCarrito > 250) || (dialogo && edad > 150) || edad > 6000;
        if (hecho) { if (el.classList.contains('mm-updating')) el.classList.remove('mm-updating'); else libera(el); }
      });
      if ($$('.mm-busy, .mm-updating').length) setTimeout(tick, 120); else vigilando = false;
    })();
  }
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('button[name="add"], .sticky-add-to-cart__button, .quick-add__button');
    if (b && !b.disabled) { ocupado(b); return; }
    var ck = t.closest('button[name="checkout"], #checkout');
    if (ck) { ocupado(ck, 'Abriendo el pago…'); ck._mmPago = 1; return; }
    var q = t.closest('.quantity-plus, .quantity-minus, .cart-items__remove');
    if (q && q.closest('cart-items-component, cart-drawer-component, .cart-drawer, main')) {
      $$('.cart-totals').forEach(function (c) { c.classList.add('mm-updating'); c._mmT0 = Date.now(); });
      vigila();
    }
  }, true);
  window.addEventListener('pageshow', function (e) { if (e.persisted) $$('.mm-busy').forEach(libera); });

  /* ---------------------------------------------------------------- arranque y repintados del tema */
  var pend = false;
  function todo() {
    pend = false;
    try { aplicaGate(); } catch (e) {}
    try { sequra(); } catch (e) {}
    try { contador(); } catch (e) {}
    try { sequraCuotas(); } catch (e) {}
    try { verMas(); } catch (e) {}
    try { if (mq.matches) ordenarMovil(); renombra(); } catch (e) {}
    try { compruebaFab(); } catch (e) {}
  }
  function programa() { if (!pend) { pend = true; requestAnimationFrame(todo); } }
  var fabPend = false;
  function programaFab() { if (!fabPend) { fabPend = true; setTimeout(function () { requestAnimationFrame(function () { fabPend = false; compruebaFab(); }); }, 90); } }

  function init() {
    todo();
    new MutationObserver(programa).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('scroll', programaFab, { passive: true });
    window.addEventListener('resize', programa);
    var fab = document.getElementById('mmc-fab');
    if (fab) new MutationObserver(programaFab).observe(fab, { attributes: true, attributeFilter: ['aria-expanded'] });
    /* Las tarjetas animan su botón «Añadir» al entrar en pantalla, sin scroll ni cambio de DOM: repaso suave cada 0,7 s. */
    setInterval(function () { if (!document.hidden) programaFab(); }, 700);
    window.addEventListener('load', function () { setTimeout(programa, 600); setTimeout(programa, 2500); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
